// extracted by mini-css-extract-plugin
module.exports = {"product":"M91zBJ","product__loading":"_12-8i0","product__header":"_2u3MYB","product__featured-image":"EB2m6i"};